<h4 class="h4-500 color-gray-100" [dataSelector]="dataSelector + '-title'">Have a question?</h4>

<p class="small-300 mt-1 mb-4" [dataSelector]="dataSelector + '-description'">Our team is here to help however we can</p>

<ng-container *ngFor="let staffMember of relevantStaff$ | async">
  <ng-container [ngSwitch]="staffMember.status">
    <div *ngSwitchCase="LoadableStatus.LOADED" class="d-flex flex-column align-items-start client-request-staff" [dataSelector]="dataSelector + '-member-container'">
      <p class="body-400 color-gray-100" [dataSelector]="dataSelector + '-member-name'">{{ staffMember.data?.name }}</p>

      <!--<p class="body-300 color-gray-400">{{ staffMember.data.title }}</p>-->

      <p class="small-300 text-color-primary-base" [dataSelector]="dataSelector + '-member-email'">{{ staffMember.data?.email }}</p>
    </div>

    <div *ngSwitchCase="LoadableStatus.ERROR" class="client-request-staff-error" [dataSelector]="dataSelector + '-error-state'">
      Error loading staff member
    </div>

    <div
      *ngSwitchDefault
      style="height: 64px;"
      class="loading-shimmer client-request-staff"
      [dataSelector]="dataSelector + '-loading-state'"
    ></div>
  </ng-container>
</ng-container>
